export default __webpack_public_path__ + "static/media/mail-failed.93bdb59b.svg";